// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-text{margin-bottom:2px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal}.light-theme .notification-text.failed{color:#d24d57}.dark-theme .notification-text.failed{color:#d24d57}", ""]);
// Exports
module.exports = exports;
